import { arrayOf, objectOf, shape, string } from 'prop-types';

import SerpwatcherTrackingType from 'types/SerpwatcherTrackingType';

export default shape({
    swTrackingsById: objectOf(SerpwatcherTrackingType),
    swTrackingsAllIds: arrayOf(string),
});
